import { useAppRouter } from '@/common/route/useAppRouter';
import { validateDateAfter, validateFormat } from '@/common/validator/validatorHelpers';
import { useCrudActions } from '@/common/view/useCrudActions';
import { useLiveops } from '@/modules/liveops/item/model/mixins';
import { ROUTE_NAME_LIVEOPS } from '@/modules/liveops/router';
import { liveopsPointService } from '@/services/liveops';
import useVuelidate from '@vuelidate/core';
import { required, requiredIf } from '@vuelidate/validators';

export function useLiveopsContentEdit() {
    const router = useAppRouter();

    const { model, fetch } = useLiveops();

    const validations = {
        name: { required },
        type: { required },
        betCosts: {
            requiredIf: requiredIf(() => model.isBetCostsShown),
            validateFormat: validateFormat(/^\d+(,\d+)*$/)
        },
        endTime: { required, validateDateAfter: validateDateAfter('closeTime') }
    };

    const v$ = useVuelidate(validations, model);

    const actions = {
        update: useCrudActions().excuteAndNotify({
            validator: v$,
            request: () =>
                liveopsPointService.item.updateContent(
                    model.id,
                    model.name,
                    model.betCosts,
                    model.type,
                    model.endTime.getTime(),
                    model.imageFile,
                    model.iconFile
                ),
            onSuccess: () =>
                router.push({ name: ROUTE_NAME_LIVEOPS.ITEM.DETAIL(model.rewardType), params: { id: model.id } })
        })
    };

    return { model, v$, fetch, actions };
}
